import { render, staticRenderFns } from "./RankTableActivators.vue?vue&type=template&id=a4f5a4aa&"
import script from "./RankTableActivators.vue?vue&type=script&lang=js&"
export * from "./RankTableActivators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports